import { styled } from '@goodfynd/theme';
import { Button } from '@goodfynd/ui';

export const StyledButton = styled(Button, {
  display: 'inline',
  borderRadius: 4,
  boxShadow: 'none',
});
